<template>
  <div class="wrapper">
    <side-bar>
      <template slot="links">
        <sidebar-link to="/dashboard" name="Tableau de bord" icon="ti-panel" />
        <sidebar-link to="/services" name="Services" icon="ti-bar-chart" />

        <sidebar-link to="/booking" name="Reservations" icon="ti-shopping-cart" />
        <sidebar-link to="/news" name="News" icon="ti-receipt" />
        <sidebar-link to="/partners" name="Partenaires" icon="ti-user" />
        <sidebar-link to="/setting" name="Paramètres" icon="ti-settings" />
        <!-- <sidebar-link to="/icons" name="Icons" icon="ti-pencil-alt2" />
        <sidebar-link to="/notifications" name="Notifications" icon="ti-bell" />
        <sidebar-link to="/maps" name="News" icon="ti-map" /> -->
      </template>
      <mobile-menu>
        <li class="nav-item">
          <a href="#" class="nav-link" @click="addCategory()">
            <i class="ti-plus"></i>
            <p>Ajouter une catégorie</p>
          </a>
        </li>
        <!-- <li class="nav-item">
          <a class="nav-link">
            <span>
              <i class="ti-bell"></i>
              <span style="
                      background-color: rgb(210, 200, 100);
                      width: 25px;
                      height: 25px;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                    " class="badge badge-pill text-primary rounded-circle">5
              </span>
            </span>
          </a>
        </li> -->

        <li class="divider"></li>
      </mobile-menu>
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>

      <dashboard-content @click.native="toggleSidebar"> </dashboard-content>

      <content-footer></content-footer>
    </div>
  </div>
</template>
<style lang="scss"></style>
<script>
import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import MobileMenu from "./MobileMenu";
export default {
  components: {
    TopNavbar,
    ContentFooter,
    DashboardContent,
    MobileMenu,
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    addCategory() {
      this.$router.push("/add-category");
    },
  },
};
</script>
